import { t } from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getIXOverlays } from './data';
import { errorReceiveIXOverlays, failedReceiveIXOverlays, receiveIXOverlays } from './slice';
export function* requestIXOverlays(action) {
    try {
        const { consumerAPI } = action.payload;
        const response = yield call(getIXOverlays, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveIXOverlays());
            }
            else if (data) {
                if (data.length < 1) {
                    throw new Error(t('NO_LOCATIONS_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveIXOverlays(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveIXOverlays());
            }
            else if (response && response.status === 200) {
                if (response.data.length < 1) {
                    throw new Error(t('NO_LOCATIONS_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveIXOverlays(response.data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveIXOverlays());
    }
}
export function* watchRequestIXOverlays() {
    yield takeLatest('ixOverlays/requestIXOverlays', requestIXOverlays);
}
